import React, { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import { Grid, Radio } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import commonActions from "../../redux/common/actions";
import dayjs from "dayjs";
import { itemsPerPage } from "../../utils/constants";
import TablePagination from "../../common/tablePagination";
import Searchbar from "../../common/searchbar";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Chip, List,
  ListItem,
  ListItemText } from '@mui/material';

export default function CourseTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
 const { backofficeTokenDetails } = useSelector((state) => state.authReducer);
  const [searchTerm, setSearchTerm] = useState("");
  const [tableData, setTableData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [moreOpen, setMoreOpen] = useState(false);
const [moreCourses, setMoreCourses] = useState([]); 
   const { templateList } = useSelector((state) => state.masterReducer);
   useEffect(() => {
    dispatch({ type: masterActions.GET_TEMPLATE_LIST });
  }, []);
//   prashanth
  useEffect(() => {
    createTabledata();
  }, [templateList, searchTerm]); // <-- added searchTerm
  const handleActive = async(active, type, templateid) => {
     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
    try {
     
      const res = await axios.patch(
        `${API_URL}/backoffice/email-template/update/active-flag`,
        null,
        { params: { templateid: templateid, isactive: type } }
      );
        if (res.data.statusCode === 200) {
          dispatch({ type: masterActions.GET_TEMPLATE_LIST });
        }
    } catch(err){
console.log(err)
    }
     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  };

  const createTabledata = () => {
    const list = templateList?.all || [];
  const filtered = list.filter(obj =>
    obj.templatename?.toLowerCase().includes(searchTerm.toLowerCase())
  );
    let data = filtered && filtered.map((obj,index) => {
    
            const courses = obj.courses || [];
          
            // Option 1: Display course names joined by commas
            const coursesDisplay = courses.map(c => c.coursename).join(', ').length > 1  ? `${courses[0].coursename} +${courses.length - 1} more` : courses[0]?.coursename ?? '—';;
          
            const names = courses.map(c => c.coursename);
            const firstTwo = names.slice(0, 2);
            const extraCount = names.length - firstTwo.length;
          
            return {
              ...obj,
              templatename: obj.templatename,
              triggername: obj.triggername,
              eventtype: obj.eventtype,
              isactive: obj.isactive,
              coursesDisplay: (
                <>
                  {firstTwo.join(', ')}
                  {extraCount > 0 && (
                    <Chip
                      label={`+${extraCount} more`}
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMoreCourses(names);
                        setMoreOpen(true);
                      }}
                      sx={{ cursor: 'pointer', ml: 1 }}
                    />
                  )}
                </>
              ), // <- transformed
              enable: (
                <Radio
                  checked={obj.isactive == true}
                  onClick={() => handleActive(obj.isactive, true, obj.templateid)}
                />
              ),
              disable: (
                <Radio
                  checked={obj.isactive == false}
                  onClick={() => handleActive(obj.isactive, false, obj.templateid)}
                />
              ),
            };
          });
        
          
    setTableData(data);
  };

//   const createTabledata = () => {
//     const filtered = courseList.all?.filter((obj) =>
//       obj.coursename.toLowerCase().includes(searchTerm.toLowerCase())
//     )
//     const data = filtered?.map((obj, index) => ({
//       ...obj,
//       id: index + 1,
//       coursecategory: obj.coursecategory,
//       coursename: obj.coursename,
//       regstartdate: dayjs(obj.regstartdate).format("DD-MM-YYYY"),
//       regenddate: dayjs(obj.regenddate).format("DD-MM-YYYY"),
//       isActive: obj.isActive,
//       courseid: obj.courseid,
//       enable: (
//         <Radio
//           checked={obj.isactive === "1"}
//           onClick={() => handleActive(obj.isactive, "1", obj.courseid)}
//         />
//       ),
//       disable: (
//         <Radio
//           checked={obj.isactive === "0"}
//           onClick={() => handleActive(obj.isactive, "0", obj.courseid)}
//         />
//       ),
//     }));

//     setTableData(data || []);
//   };
//   useEffect(() => {
//     dispatch({ type: masterActions.GET_COURSE_LIST });
//   }, []);
  const tableKeys = [
    { name: "S.No", accessor: "id", sortOption: false },
  { name: "Template Name", accessor: "templatename", sortOption: false },
  { name: "Trigger Name", accessor: "triggername", sortOption: false },
  { name: "Event Type", accessor: "eventtype", sortOption: false },
  { name: "Form Names", accessor: "coursesDisplay", sortOption: false },
  { name: "Enable", accessor: "enable", sortOption: false },
  { name: "Disable", accessor: "disable", sortOption: false },
  ];


  const handleTemplateUpdate = async(templateid) => {
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
    try {
      const res = await axios.get(
        `${API_URL}/backoffice/email-template/${templateid}`
      );
        navigate(`/${Cookies.get("mhet_mst_project")}/add-template?page=updatetemplate`, {
          state: { updatetemplateDetails: res.data.result },
        });
        
      
      
    } catch (err) {
      console.error(err);
    }
     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  };

  

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData && tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleTemplatePreview=async(templateid)=>{
     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });

    try {
      const res = await axios.get(
        `${API_URL}/backoffice/email-template/${templateid}`
      );
        navigate(`/${Cookies.get("mhet_mst_project")}/add-template?page=previewtemplate`, {
          state: { templateDetails: res.data.result },
        });
      
      // Refresh list, show feedback, etc.
    } catch (err) {
      console.error(err);
    }
     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
  const handleTemplateDelete=async(templateid)=>{
     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
    try {
      const res = await axios.delete(
        `${API_URL}/backoffice/email-template/delete/${templateid}`
      );
        dispatch({ type: masterActions.GET_TEMPLATE_LIST });
      
      // Refresh list, show feedback, etc.
    } catch (err) {
      console.error(err);
    }
     dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });

  }
  const handleTemplateSendMail=async(templateid)=>{

    try {
      const res = await axios.post(
        `${API_URL}/backoffice/email-template/test-mail/${templateid}`
      );
      console.log(res,"prashanth")
       if(res.data.statusCode==200){
        dispatch({
                        type: commonActions.SET_ALERT,
                        payload: {
                          status: "success",
                          show: true,
                          message:
                            "Email Sent.",
                        },
                      });
                       setTimeout(()=>{
                                      dispatch({
                                          type: commonActions.SET_ALERT,
                                          payload: { status: null, show: false, message: null },
                                    })
                                    },[2000])
       }
      
      // Refresh list, show feedback, etc.
    } catch (err) {
    dispatch({
                        type: commonActions.SET_ALERT,
                        payload: {
                          status: "failed",
                          show: true,
                          message:
                            "Email Sent Failed.",
                        },
                      });
                       setTimeout(()=>{
                                      dispatch({
                                          type: commonActions.SET_ALERT,
                                          payload: { status: null, show: false, message: null },
                                    })
                                    },[2000])
                                  }
  }
  return (
    <>
    <Grid>
      <Grid item lg={7} md={7} sm={12} style={{marginBottom:"5px"}}>
        <Searchbar 
        handleSearch={handleSearch} value={searchTerm} 
        />
      </Grid>
      <DataTable
        keys={tableKeys}
        values={currentItems}
        page={"templatelist"}
        handleTemplateUpdate={handleTemplateUpdate}
        handleTemplatePreview={handleTemplatePreview}
        handleTemplateDelete={handleTemplateDelete}
        handleTemplateSendMail={handleTemplateSendMail}
      />
      <TablePagination
        pageCount={pageCount}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
      />
    </Grid>
    <Dialog open={moreOpen} onClose={() => setMoreOpen(false)}>
    <DialogTitle>All Selected Courses</DialogTitle>
    <DialogContent dividers>
    {moreCourses.map((name, idx) => (
        <ListItem key={idx}  divider={idx < moreCourses.length - 1}>
          <ListItemText primary={name} />
        </ListItem>
      ))}
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setMoreOpen(false)}>Close</Button>
    </DialogActions>
  </Dialog>
  </>
  );
}
